﻿<template>
    <div class="w-48">Name</div>
    <div><b>{{pax.first_name}} {{pax.family_name}}</b></div>
    <div class="w-48" :hidden="!Lead_Passenger()">Email</div>
    <div :hidden="!Lead_Passenger()"><b>{{pax.email}}</b></div>
    <div class="w-48" :hidden="!Lead_Passenger()">Phone Number</div>
    <div :hidden="!Lead_Passenger()"><b>{{pax.telephone_number}}</b></div>
    <div class="w-48" :hidden="!Lead_Passenger()">Postcode</div>
    <div :hidden="!Lead_Passenger()"><b>{{pax.post_code}}</b></div>
</template>

<script lang="ts" src="./passenger.ts"></script>